import request from './request';

/**
 * 获取系统环境信息
 * 返回：{ serverId: 'prod' | 'staging', knowledgeVersionStrategy: 'published' | 'latest' }
 */
export function getSystemInfo() {
  return request({
    url: '/system/info',
    method: 'get',
  });
}
